export default "__VITE_ASSET__7vGxI8Jv__"